import React from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Link } from "react-router-dom";

const styles = {
  bottom_bar: {
    marginTop: "2%",
    backgroundColor: "#FAFAFA",
    boxShadow: "none",
    borderTop: "2px solid #E0E0E0",
  },
  bottom_bar_title_text: {
    fontFamily: "Open Sans",
    fontSize: 18,
  },
  bottom_bar_text: {
    fontFamily: "Open Sans",
    fontSize: 18,
    marginBottom: -10,
  },
};

class BottomBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSafari: false,
    };
  }

  componentDidMount() {
    const isItSafari = /^((?!chrome|android).)*safari/i.test(
      navigator.userAgent
    );
    this.setState({ isSafari: isItSafari });
  }

  render() {
    const { classes } = this.props;
    const { isSafari } = this.state;

    return (
      <Grid className={classes.bottom_bar}>
        <Grid
          container
          justify="center"
          alignItems="center"
          style={{ paddingTop: "2%", paddingBottom: "2%" }}
        >
          <Grid
            item
            container
            xs={12}
            md={isSafari ? 2 : 4}
            direction="column"
            justify={window.innerWidth <= 760 ? "left" : "center"}
            alignContent={window.innerWidth <= 760 ? "left" : "center"}
            style={{
              margin: window.innerWidth <= 760 ? 24 : 0,
            }}
          >
            <b className={classes.bottom_bar_title_text}>Company</b>
            <Link
              to={{
                pathname: "/about",
                state: { prevPath: "Privacy Policy | CanaWho" },
              }}
              style={{
                color: "black",
                fontFamily: "Open Sans",
                textDecoration: "none",
              }}
            >
              <p className={classes.bottom_bar_text}>About Us</p>
            </Link>
            <Link
              to={{
                pathname: "/contact",
                state: { prevPath: "Privacy Policy | CanaWho" },
              }}
              style={{
                color: "black",
                fontFamily: "Open Sans",
                textDecoration: "none",
              }}
            >
              <p className={classes.bottom_bar_text}>Contact</p>
            </Link>
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={isSafari ? 2 : 4}
            direction="column"
            justify={window.innerWidth <= 760 ? "left" : "center"}
            alignContent={window.innerWidth <= 760 ? "left" : "center"}
            style={{ margin: window.innerWidth <= 760 ? 24 : 0 }}
          >
            <b className={classes.bottom_bar_title_text}>Company Community</b>
            <Link
              to={{
                pathname: "/join",
                state: { prevPath: "Join Community | CanaWho" },
              }}
              style={{
                color: "black",
                fontFamily: "Open Sans",
                textDecoration: "none",
              }}
            >
              <p className={classes.bottom_bar_text}>Join the Community</p>
            </Link>
            <Link
              to={{
                pathname: "/login",
                state: { prevPath: "Join Community | CanaWho" },
              }}
              style={{
                color: "black",
                fontFamily: "Open Sans",
                textDecoration: "none",
              }}
            >
              <p className={classes.bottom_bar_text}>Sign into the Community</p>
            </Link>
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={isSafari ? 2 : 4}
            direction="column"
            justify={window.innerWidth <= 760 ? "left" : "center"}
            alignContent={window.innerWidth <= 760 ? "left" : "center"}
            style={{ margin: window.innerWidth <= 760 ? 24 : 0 }}
          >
            <b className={classes.bottom_bar_title_text}>Legal</b>
            <Link
              to={{
                pathname: "/policy",
                state: { prevPath: "Privacy Policy | CanaWho" },
              }}
              style={{
                color: "black",
                fontFamily: "Open Sans",
                textDecoration: "none",
              }}
            >
              <p className={classes.bottom_bar_text}>Privacy Policy</p>
            </Link>
            <Link
              to={{
                pathname: "/policy",
                state: { prevPath: "Terms of Service | CanaWho" },
              }}
              style={{
                color: "black",
                fontFamily: "Open Sans",
                textDecoration: "none",
              }}
            >
              <p className={classes.bottom_bar_text}>Terms of Service</p>
            </Link>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

BottomBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BottomBar);
